import api from './client'

export async function getMyBranches() {
  const { data } = await api.get('/manager/my-branches')
  return Array.isArray(data) ? data : []
}

export async function getMyBranchRole(branchId) {
  const { data } = await api.get('/manager/auth/my-role', {
    params: { branch_id: branchId },
  })
  return data ?? null
}

// Backward-compatible alias for existing callers.
export const getBranchesByOrg = getMyBranches
